export const platformSchema = {
    type: 'object',
    properties: {
        name: { type: 'string' },
        lang: {
            type: 'object',
            properties: {
                available: {
                    type: 'array',
                    items: { type: 'string' },
                },
                default: { type: 'string' },
            },
        },
        primaryCard: {
            type: 'object',
            properties: {
                type: { type: 'string' },
                propagateToEnabledCards: { type: 'boolean' },
            },
        },
        support: {
            type: 'object',
            properties: {
                cards: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            regex: { type: 'string' },
                            barcode: { type: 'string' },
                            startSequence: { type: 'string' },
                            prefix: { type: 'string' },
                            lifespan: { type: 'number' },
                            suffix: { type: 'string' },
                            renewalDelay: { type: 'number' },
                            proofOfIdentityCount: { type: 'number' },
                            regexBarcode: { type: 'string' },
                            linkSystExt: { type: 'boolean' },
                            requiredCards: {
                                type: 'array',
                                items: { type: 'string' },
                            },
                            enableCards: {
                                type: 'array',
                                items: { type: 'string' },
                            },
                            availableSubTypes: {
                                type: 'array',
                                items: { type: 'string' },
                            },
                            requiredSubTypes: {
                                type: 'array',
                                items: { type: 'string' },
                            },
                            linkable: { type: 'boolean' },
                            identity: {
                                type: 'object',
                                properties: {
                                    label: {
                                        type: 'object',
                                        properties: {
                                            fr: { type: 'string' },
                                            en: { type: 'string' },
                                        },
                                    },
                                    icon: { type: 'string' },
                                    instructions: {
                                        type: 'object',
                                        properties: {
                                            general: {
                                                type: 'object',
                                                properties: {
                                                    introduction: {
                                                        type: 'object',
                                                        properties: {
                                                            fr: { type: 'string' },
                                                            en: { type: 'string' },
                                                        },
                                                    },
                                                },
                                            },
                                            steps: {
                                                type: 'object',
                                                properties: {
                                                    info: {
                                                        type: 'object',
                                                        properties: {
                                                            fr: { type: 'string' },
                                                            en: { type: 'string' },
                                                        },
                                                    },
                                                    attachments: {
                                                        type: 'object',
                                                        properties: {
                                                            fr: { type: 'string' },
                                                            en: { type: 'string' },
                                                        },
                                                    },
                                                    confirmation: {
                                                        type: 'object',
                                                        properties: {
                                                            fr: { type: 'string' },
                                                            en: { type: 'string' },
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                            tooltips: {
                                type: 'object',
                                properties: {
                                    subscribe: {
                                        type: 'object',
                                        properties: {
                                            fr: { type: 'string' },
                                            en: { type: 'string' },
                                        },
                                    },
                                    link: {
                                        type: 'object',
                                        properties: {
                                            fr: { type: 'string' },
                                            en: { type: 'string' },
                                        },
                                    },
                                },
                            },
                            autoApprove: { type: 'boolean' },
                        },
                    },
                },
            },
        },
        family: {
            type: 'object',
            properties: {
                links: {
                    type: 'array',
                    items: { type: 'string' },
                },
                instructions: {
                    type: 'object',
                    properties: {
                        fr: { type: 'string' },
                        en: { type: 'string' },
                    },
                },
                proofOfIdentityCount: { type: 'number' },
            },
        },
        adminTabs: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: { type: 'string' },
                    tag: { type: 'string' },
                    titleKey: { type: 'string' },
                    pluginId: { type: 'string' },
                    visible: { type: 'boolean' },
                    order: { type: 'number' },
                },
            },
        },
        subTypes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    tag: { type: 'string' },
                    color: { type: 'string' },
                    name: {
                        type: 'object',
                        properties: {
                            fr: { type: 'string' },
                            en: { type: 'string' },
                        },
                    },
                },
            },
        },
        dummyAccount: { type: 'boolean' },
        emailChannelAutoSubscription: { type: 'boolean' },
        frenchLanguageCharterBanner: { type: 'boolean' },
        cardPrint: {
            canUserPrintCitizenCard: { type: 'boolean' },
        },
        ecolocal: { type: 'boolean' },
        dashboardUrl: {
            type: 'object',
            properties: {
                fr: { type: 'string' },
                en: { type: 'string' },
            },
        },
    },
};
